import { defineComponent as _defineComponent } from 'vue'
import textfield from "@busy-human/vue-component-library/components/text-field.vue"
import TextField from './text-area.vue'
import loader from "../components/loader.vue"
import {computed, onMounted, ref} from 'vue'
import {functions} from '@/util/firebase'
import { httpsCallable} from 'firebase/functions'
import {checkLoggedIn} from '@/util/auth'
import { useUserspace } from "@/store/userspace"


export default /*#__PURE__*/_defineComponent({
  __name: 'feedback',
  setup(__props, { expose }) {
  expose();

let name = ref(null)
let response = ref<string | undefined>()
let loading = ref(false)

const isLoggedIn = computed(() => checkLoggedIn());

const sendFeedbackEmail = httpsCallable<{name: string, response: string}, boolean>(functions, 'sendFeedbackEmail');

const submitFeedbackEmail = async () => {
    loading.value = true;
    
    const userData = useUserspace().user;

    if (name.value != null && response.value != null) {
        const res = await sendFeedbackEmail({
            name: name.value, 
            response: response.value
        })
        if(res.data === true) {
        } else {
            console.error("Failed to send feedback");
        }
        loading.value = false;
    }
}

const __returned__ = { name, response, loading, isLoggedIn, sendFeedbackEmail, submitFeedbackEmail, textfield, TextField, loader, computed, onMounted, ref, functions, httpsCallable, checkLoggedIn, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})